import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PageScrollTop from './components/pageToTop/PageScrollTop'

// Pages import Here 
import WebAgency from "./pages/WebAgency";


import CategoryList from "./pages/CategoryList";
import TagList from "./pages/TagList";
import Author from "./pages/Author";
import AboutUs from "./pages/AboutUs";

// Elements import Here 

import Elements from "./elements/elements/Elements";
import Button from "./elements/button/Button";
import Service from "./elements/service/Service";
import CounterUp from "./elements/counterup/CounterUp";
import Progressbar from "./elements/progressbar/Progressbar";

import Portfolio from "./elements/portfolio/Portfolio";
import portfolioThreeColumn from "./elements/portfolio/PortfolioThreeColumn";
import PortfolioFullWidth from "./elements/portfolio/PortfolioFullWidth";
import PortfolioGrid from "./elements/portfolio/PortfolioGrid";
import PortfolioBoxLayout from "./elements/portfolio/PortfolioBoxLayout";
import PortfolioDetails from "./pages/PortfolioDetails";
import Social from "./elements/social/Social";
import Team from "./elements/team/Team";
import Timeline from "./elements/timeline/Timeline";
import Testimonial from "./elements/testimonial/Testimonial";
import RnAccordion from "./elements/accordion/RnAccordion";
import Tab from "./elements/tab/Tab";
import Pricing from "./elements/pricing/Pricing";
import Split from "./elements/split/Split";
import CalltoAction from "./elements/calltoaction/CalltoAction";
import Video from "./elements/video/Video";
import Gallery from "./elements/gallery/Gallery";
import Contact from "./elements/contact/Contact";
import Brand from "./elements/brand/Brand";
import AdvanceTab from "./elements/advancetab/AdvanceTab";
import AdvancePricing from "./elements/advancePricing/AdvancePricing";


import BlogGridView from "./components/blog/BlogGridView";
import BlogListView from "./components/blog/BlogListView";
import BlogGridSidebar from "./components/blog/BlogGridSidebar";
import BlogListSidebar from "./components/blog/BlogListSidebar";
import BlogDetails from "./pages/BlogDetails";
import Error from "./pages/Error";


// Import Css Here 
import './assets/scss/style.scss';
import WordpressDevelopment from './pages/service-pages/WordpressDevelopment';
import ShopifyDevelopment from './pages/service-pages/ShopifyDevelopment';
import AngularJSDevelopment from './pages/service-pages/AngularDevelopment';
import DotNetDevelopment from './pages/service-pages/DotNetDevelopment';
import WebsiteMaintenance from './pages/service-pages/WebsiteMaintenance';
import LaravelDevelopment from './pages/service-pages/LaravelDevelopment';
import FullStackNextDevelopment from './pages/service-pages/FullStackNextDevelopment';
import UIUXDesign from './pages/service-pages/UIUXDesign';
import SEOpage from './pages/service-pages/SEO';
import LogoDesign from './pages/service-pages/LogoDesign';
import MobileAppDevelopment from './pages/service-pages/MobileAppDevelopment';
import CustomAppsDevelopment from './pages/service-pages/CustomAppsDevelopment';
import CrossPlatformApps from './pages/service-pages/CrossPlatformApps';
import ProgressiveWebApps from './pages/service-pages/ProgressiveWebApps';
import CRMDev from './pages/service-pages/CRMDev';
import ERPDev from './pages/service-pages/ERPDev';
import GameDevelopment from './pages/service-pages/GameDevelopment';
import AIMLSolutions from './pages/service-pages/AIMLSolutions';
import VideoEditing from './pages/service-pages/VideoEditing';


const App = () => {
    return (
        <Router>
            <PageScrollTop>
                <Switch>
                    <Route path={`${process.env.PUBLIC_URL + "/"}`} exact component={WebAgency} />

                    {/* Blog Part  */}
                    <Route path={`${process.env.PUBLIC_URL + "/blog-grid"}`} exact component={BlogGridView} />
                    <Route path={`${process.env.PUBLIC_URL + "/blog-list-view"}`} exact component={BlogListView} />
                    <Route path={`${process.env.PUBLIC_URL + "/blog-grid-sidebar"}`} exact component={BlogGridSidebar} />
                    <Route path={`${process.env.PUBLIC_URL + "/blog-list-sidebar"}`} exact component={BlogListSidebar} />
                    <Route path={`${process.env.PUBLIC_URL + "/blog-details/:id"}`} exact component={BlogDetails} />
                    <Route path={`${process.env.PUBLIC_URL + "/category/:slug"}`} exact component={CategoryList} />
                    <Route path={`${process.env.PUBLIC_URL + "/archive/:slug"}`} exact component={Author} />
                    <Route path={`${process.env.PUBLIC_URL + "/tag/:slug"}`} exact component={TagList} />

                    <Route path={`${process.env.PUBLIC_URL + "/elements"}`} exact component={Elements} />
                    <Route path={`${process.env.PUBLIC_URL + "/button"}`} exact component={Button} />
                    <Route path={`${process.env.PUBLIC_URL + "/service"}`} exact component={Service} />
                    <Route path={`${process.env.PUBLIC_URL + "/counter"}`} exact component={CounterUp} />
                    <Route path={`${process.env.PUBLIC_URL + "/progressbar"}`} exact component={Progressbar} />
                    <Route path={`${process.env.PUBLIC_URL + "/social-share"}`} exact component={Social} />
                    <Route path={`${process.env.PUBLIC_URL + "/team"}`} exact component={Team} />
                    <Route path={`${process.env.PUBLIC_URL + "/testimonial"}`} exact component={Testimonial} />
                    <Route path={`${process.env.PUBLIC_URL + "/timeline"}`} exact component={Timeline} />
                    <Route path={`${process.env.PUBLIC_URL + "/accordion"}`} exact component={RnAccordion} />
                    <Route path={`${process.env.PUBLIC_URL + "/tab"}`} exact component={Tab} />
                    <Route path={`${process.env.PUBLIC_URL + "/pricing"}`} exact component={Pricing} />
                    <Route path={`${process.env.PUBLIC_URL + "/split"}`} exact component={Split} />
                    <Route path={`${process.env.PUBLIC_URL + "/call-to-action"}`} exact component={CalltoAction} />
                    <Route path={`${process.env.PUBLIC_URL + "/video-popup"}`} exact component={Video} />
                    <Route path={`${process.env.PUBLIC_URL + "/gallery"}`} exact component={Gallery} />
                    <Route path={`${process.env.PUBLIC_URL + "/contact"}`} exact component={Contact} />
                    <Route path={`${process.env.PUBLIC_URL + "/brand"}`} exact component={Brand} />
                    <Route path={`${process.env.PUBLIC_URL + "/advance-tab"}`} exact component={AdvanceTab} />
                    <Route path={`${process.env.PUBLIC_URL + "/advance-pricing"}`} exact component={AdvancePricing} />
                    <Route path={`${process.env.PUBLIC_URL + "/about-us"}`} exact component={AboutUs} />

                    <Route path={`${process.env.PUBLIC_URL + "/error"}`} exact component={Error} />

                    <Route path={`${process.env.PUBLIC_URL + "/portfolio"}`} exact component={Portfolio} />
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-three-column"}`} exact component={portfolioThreeColumn} />
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-full-width"}`} exact component={PortfolioFullWidth} />
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-grid-layout"}`} exact component={PortfolioGrid} />
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-box-layout"}`} exact component={PortfolioBoxLayout} />
                    <Route path={`${process.env.PUBLIC_URL + "/portfolio-details/:id"}`} exact component={PortfolioDetails} />

                    {/* services */}
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/ai-ml-solutions/ai-ml-solutions/"}`} exact component={AIMLSolutions} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/game-development/game-development/"}`} exact component={GameDevelopment} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/web-development/wordpress-development/"}`} exact component={WordpressDevelopment} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/web-development/shopify-web-development/"}`} exact component={ShopifyDevelopment} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/web-development/angularjs-development/"}`} exact component={AngularJSDevelopment} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/web-development/dotnet-development/"}`} exact component={DotNetDevelopment} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/web-development/website-maintenance/"}`} exact component={WebsiteMaintenance} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/web-development/laravel-development/"}`} exact component={LaravelDevelopment} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/web-development/full-stack-development-with-next-js/"}`} exact component={FullStackNextDevelopment} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/our-services/web-design/video-editing/"}`} exact component={VideoEditing} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/our-services/web-design/ui-ux-design/"}`} exact component={UIUXDesign} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/graphic-design/logo-design/"}`} exact component={LogoDesign} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/digital-marketing/seo/"}`} exact component={SEOpage} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/mobile-app-solutions/mobile-app-development/"}`} exact component={MobileAppDevelopment} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/mobile-app-solutions/custom-app-development/"}`} exact component={CustomAppsDevelopment} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/mobile-app-solutions/cross-platform-development/"}`} exact component={CrossPlatformApps} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/mobile-app-solutions/progressive-web-apps/"}`} exact component={ProgressiveWebApps} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/enterprise-solutions/crm/"}`} exact component={CRMDev} />
                    <Route path={`${process.env.PUBLIC_URL + "/our-services/enterprise-solutions/erp/"}`} exact component={ERPDev} />

                </Switch>
            </PageScrollTop>
        </Router>
    )
}


export default App
